import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, usePermissions } from 'react-admin';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import RedeemIcon from '@material-ui/icons/Redeem';
import { PERMISSIONS } from './constants';

const Menu = ({ onMenuClick, logout }) => {
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    const { permissions } = usePermissions();
    const canCreateCustomer = (permissions || []).includes(PERMISSIONS.CREATE_CUSTOMER);
    return (
        <div>
            <MenuItemLink
                to="/statement"
                primaryText="Extrato"
                leftIcon={<ListAltIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            <MenuItemLink
                to="/redeem"
                primaryText="Resgate"
                leftIcon={<AccountBalanceWalletOutlinedIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            <MenuItemLink
                to="/register"
                primaryText="Cadastro"
                leftIcon={<AssignmentIndOutlinedIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            {canCreateCustomer && (
                <MenuItemLink
                    to="/customers-create"
                    primaryText="Cadastrar Cliente"
                    leftIcon={<PersonAddOutlinedIcon />}
                    onClick={onMenuClick}
                    sidebarIsOpen={open}
                />
            )}
            <MenuItemLink
                to="/gift"
                primaryText="Brindes"
                leftIcon={<RedeemIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            />
            {isXSmall && logout}
        </div>
    );
}

export default Menu;
